import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "common-layout"
}
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "about" }
const _hoisted_4 = { class: "content" }

import THeader from "@/components/Header.vue";
import Sidebar from "@/components/Sidebar.vue";
import Tags from "@/components/Tags.vue";
import {computed} from "vue";
import store from "@/store";

export default /*@__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const collapse = computed(() => {
  return store.state.collapse;
})

return (_ctx: any,_cache: any) => {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_el_container, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_header, { style: {"padding":"0"} }, {
                default: _withCtx(() => [
                  _createVNode(THeader)
                ]),
                _: 1
              }),
              _createVNode(_component_el_container, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_aside, { width: "200px" }, {
                    default: _withCtx(() => [
                      _createVNode(Sidebar)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_main, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["content-box", { 'content-collapse': collapse.value }])
                      }, [
                        _createVNode(Tags),
                        _createElementVNode("div", _hoisted_2, [
                          _createVNode(_component_router_view, null, {
                            default: _withCtx(({ Component   }) => [
                              (_openBlock(), _createBlock(_KeepAlive, null, [
                                (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                              ], 1024))
                            ]),
                            _: 1
                          })
                        ])
                      ], 2)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(THeader),
      _createVNode(Sidebar),
      _createElementVNode("div", {
        class: _normalizeClass(["content-box", { 'content-collapse': collapse.value }])
      }, [
        _createVNode(Tags),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_view, null, {
            default: _withCtx(({ Component   }) => [
              (_openBlock(), _createBlock(_KeepAlive, null, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
              ], 1024))
            ]),
            _: 1
          })
        ])
      ], 2)
    ])
  ], 64))
}
}

})